import React, { FC } from 'react'

import Layout, { LayoutProps } from '../../layouts/Layout'
import { LoginFormProps } from '../../components/forms/LoginForm'
import { ForgotPasswordFormProps } from '../../components/forms/ForgotPasswordForm'
import { LinkProps } from '../../components/Link'
import { Icons } from '../../components/Icon/types'

import * as SC from './styled'

export type LoginTemplateProps = {
  className?: string
  layoutProps?: LayoutProps
  title?: string
  image?: {
    src: string
  }
  loginForm?: LoginFormProps
  forgotPassword?: {
    form: ForgotPasswordFormProps
    back: {
      label: string
      link: LinkProps
    }
  }
}

const LoginTemplate: FC<LoginTemplateProps> = (props) => {
  const { title, image, layoutProps, loginForm, forgotPassword } = props

  return (
    <Layout {...layoutProps}>
      <SC.Content>
        <SC.Box>
          <SC.LogoIcon icon={Icons.logo} />
          {image && <SC.Image src={image.src} alt="" />}
          {title && <SC.Title>{title}</SC.Title>}
          {loginForm && <SC.LoginFormC {...loginForm} />}
          {forgotPassword && (
            <>
              <SC.ForgotPasswordFormC {...forgotPassword.form} />
              <SC.ForgotPasswordLink {...forgotPassword.back.link}>
                <SC.ForgotPasswordLinkIcon icon={Icons.chevronLeft} />
                {forgotPassword.back.label}
              </SC.ForgotPasswordLink>
            </>
          )}
        </SC.Box>
      </SC.Content>
    </Layout>
  )
}

export default LoginTemplate
